import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { WHATSAPP_TEMPLATES_QUERY_KEY } from '@/api/queries/whatsapp-templates/key';
import { createWhatsAppTemplate, syncWhatsAppTemplates } from './request';

const invalidateTemplates = (
  queryClient: ReturnType<typeof useQueryClient>
) => {
  queryClient.invalidateQueries({ queryKey: [WHATSAPP_TEMPLATES_QUERY_KEY] });
};

export const useCreateWhatsAppTemplate = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createWhatsAppTemplate,
    onSuccess: ({ response }) => {
      toast.success(response || 'Template created successfully');
      invalidateTemplates(queryClient);
      onSuccess?.();
    },
  });
};

export const useSyncWhatsAppTemplates = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: syncWhatsAppTemplates,
    onSuccess: ({ response }) => {
      toast.success(response || 'Templates synced successfully');
      invalidateTemplates(queryClient);
      onSuccess?.();
    },
  });
};
